"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var dashbord = _interopRequireWildcard(require("@/api/dashboard"));
var _format = require("@/utils/format");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: ["areaId"],
  data: function data() {
    return {
      orderType: "orderFood",
      orderTypes: [{
        name: "Thức ăn",
        key: "orderFood"
      }, {
        name: "Giao hàng",
        key: "orderDelivery"
      }, {
        name: "Di chuyển",
        key: "orderTransport"
      }],
      tableData: []
    };
  },
  watch: {
    areaId: {
      handler: function handler(val) {
        this.getTableData();
      }
    }
  },
  created: function created() {
    this.getTableData();
  },
  methods: {
    formatCurrency: function formatCurrency(n) {
      return (0, _format.formatCurrency)(n);
    },
    getTableData: function getTableData() {
      var _this = this;
      dashbord.top5Driver({
        areaId: this.areaId,
        limit: 20
      }).then(function (res) {
        _this.tableData = res.data.top5;
      });
    }
  }
};